import React from 'react';
import { createRoot } from 'react-dom/client'
import './index.css'
import './styles/stylesheet.scss';
import App from './App'

const container = document.getElementById('root');
if (!container) throw new Error("Root container not found");
const root = createRoot(container as HTMLElement); // Use '!' if you are sure it exists
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);